import { Controller } from '@hotwired/stimulus';
import { setParam } from '../helpers';
import Axios from '../axios';

const getNumerals = (input) => {
    return input.value.match(/\d+/);
}

export default class extends Controller {

    static targets = ['price-range', 'price-min', 'price-max', 'single-filter', 'active-filters', 'clear-filters', 'filters'];

    chipComponent = 'wc-block-components-chip';
    priceRangeChip = 'price-range-chip';

    connect() {
        this.currency = this.element.dataset.currency ?? '€';
        const priceRange = this.targets.find('price-range');
        const filters = this.targets.findAll('single-filter');
        const clearFilters = this.targets.find('clear-filters');
        this.activeFiltersList = {};

        if (priceRange) {
            this.priceSlider();
        }

        // Clear all active filters.
        if (clearFilters) {
            clearFilters.addEventListener('click', () => {
                history.replaceState(null, null, window.location.href.split('?')[0]);
                this.activeFiltersList = [];
                this.removeAllChips();
                this.toggleFilterDisplay(false);
                this.performFilterQuery();
            });
        }

        if (filters) {
            filters.forEach((filter) => {
                // Add chips from initial checked checkboxes.
                filter.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
                    const name = input.getAttribute('data-name');
                    const value = input.getAttribute('data-value');
                    this.addChip(name + '_' + value, input.parentElement.textContent);
                });
                // Add/Update chips & url parameters when toggling checkboxes.
                filter.querySelectorAll('input[type="checkbox"]').forEach((input) => {
                    input.addEventListener('change', () => {
                        const name = input.getAttribute('data-name');
                        const value = input.getAttribute('data-value');
                        if (input.checked) {
                            setParam('query_type_' + name.replace('filter_', ''), 'or');
                            this.addChip(`${name}_${value}`, input.parentElement.textContent, true);
                        } else {
                            setParam('query_type_' + name.replace('filter_', ''), '');
                            this.removeChip(input.value);
                        }

                        let values = [];
                        this.element.querySelectorAll(`.attribute-filter--single-${name} input`).forEach((input2) => {
                            if (input2.checked) {
                                values.push(input2.getAttribute('data-value'));
                            }
                        });

                        setParam(name, values.toString());
                        this.activeFiltersList[name] = values.toString();
                        this.performFilterQuery();
                    });
                });
            });
        }

        this.activeFilters();
    }

    // Remove chips & url parameters when clicking on active filter chips. Also uncheck checked checkboxes.
    activeFilters() {
        const activeFilters = this.targets.find('active-filters');
        if (activeFilters) {
            activeFilters.addEventListener('click', (e) => {
                if (e.target.matches(`.${this.chipComponent}, .${this.chipComponent} *`)) {
                    const chip = e.target.closest(`.${this.chipComponent}`);
                    if (chip.classList.contains(this.priceRangeChip)) {
                        setParam('min_price', '');
                        setParam('max_price', '');
                        this.activeFiltersList['min_price'] = '';
                        this.activeFiltersList['max_price'] = '';
                        this.removeChip(chip.id, true);
                        this.performFilterQuery();
                        return;
                    }

                    let attribute = this.element.querySelector(`input[value="${chip.id}"]`);
                    attribute.checked = false;

                    const name = 'filter_' + attribute.value.split("_")[1];
                    let values = [];
                    this.element.querySelectorAll(`.attribute-filter--single-${name} input`).forEach((input) => {
                        if (input.checked) {
                            values.push(input.getAttribute('data-value'));
                        }
                    });

                    setParam('query_type_' + name.replace('filter_', ''), '');
                    setParam(name, values.toString());
                    this.activeFiltersList[name] = values.toString();
                    this.removeChip(chip.id, true);
                    this.performFilterQuery();
                }
            });
        }
    }

    priceSlider() {
        const priceRange = this.targets.find('price-range');
        const priceMin = this.targets.find('price-min');
        const priceMax = this.targets.find('price-max');

        // import('nouislider').then(noUiSlider => {
        //     const startMin = parseInt(priceRange.getAttribute('data-start-min')) ?? 0;
        //     const startMax = parseInt(priceRange.getAttribute('data-start-max')) ?? 0;
        //     const rangeMin = parseInt(priceRange.getAttribute('data-range-min')) ?? 0;
        //     const rangeMax = parseInt(priceRange.getAttribute('data-range-max')) ?? 0;
        //
        //     noUiSlider.create(priceRange, {
        //         start: [startMin, startMax],
        //         connect: true,
        //         range: {
        //             'min': rangeMin,
        //             'max': rangeMax
        //         }
        //     });
        //
        //     priceRange.noUiSlider.on('slide', (values) => {
        //         const min = parseInt(values[0]);
        //         const max = parseInt(values[1]);
        //         if (priceMin && priceMax) {
        //             priceMin.value = `${min} ${this.currency}`;
        //             priceMax.value = `${max} ${this.currency}`;
        //         }
        //         this.addChip(this.priceRangeChip, `${min} ${this.currency} - ${max} ${this.currency}`, true);
        //         setParam('min_price', min);
        //         setParam('max_price', max);
        //         this.activeFiltersList['min_price'] = min;
        //         this.activeFiltersList['max_price'] = max;
        //         this.performFilterQuery();
        //     });
        //
        //     if (priceMin && priceMax) {
        //         [priceMin, priceMax].forEach((element) => {
        //             element.addEventListener('change', () => {
        //                 priceRange.noUiSlider.set([getNumerals(priceMin)[0], getNumerals(priceMax)]);
        //                 setParam('min_price', getNumerals(priceMin));
        //                 setParam('max_price', getNumerals(priceMax));
        //                 this.activeFiltersList['min_price'] = getNumerals(priceMin);
        //                 this.activeFiltersList['max_price'] = getNumerals(priceMax);
        //                 this.performFilterQuery();
        //             });
        //         });
        //         [priceMin, priceMax].forEach((element) => {
        //             element.addEventListener('input', () => {
        //                 if (element.value.length) {
        //                     element.style.width = element.value.length + 'ch';
        //                 }
        //             });
        //             if (element.value.length) {
        //                 element.style.width = element.value.length + 'ch';
        //             }
        //         });
        //     }
        //
        //     if (priceMin && priceMax) {
        //         if (rangeMin !== startMin || rangeMax !== startMax) {
        //             this.addChip(this.priceRangeChip, `${priceMin.value} - ${priceMax.value}`, true);
        //         }
        //     }
        // });
    }

    addChip(id, name, replace = false) {
        if (replace) {
            this.removeChip(id);
        }
        this.targets.find('active-filters').insertAdjacentHTML('beforeend', `<span class="${this.chipComponent} ${id}" id="${id}"><span class="${this.chipComponent}__text">${name}</span><button class="${this.chipComponent}__remove"></button></span>`);
        this.toggleFilterDisplay(true);
    }

    removeChip(id, uncheckInputs = false) {
        const activeFilters = this.targets.find('active-filters');
        const chip = activeFilters.querySelector(`#${id}`);
        if (chip) {
            chip.remove();
        }

        if (uncheckInputs) {
            let input = this.element.querySelector(`input[value="${id}"]`);
            if (input) {
                input.checked = false;
            }
        }
        if ( !activeFilters.hasChildNodes() ) {
            this.toggleFilterDisplay(false);
        }
    }

    removeAllChips() {
        this.targets.find('active-filters').querySelectorAll(`.${this.chipComponent}`).forEach((chip) => {
            this.removeChip(chip.id, true);
        });
    }

    toggleFilterDisplay(visible = false) {
        const filter = document.querySelector('.woocommerce-active-filters');
        visible ? filter.classList.remove('hidden') : filter.classList.add('hidden');
    }

    performFilterQuery() {
        const query = this.targets.find('filters');
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        if (query && query.value) {
            let data = JSON.parse(query.value);
            for (const prop in this.activeFiltersList) {
                if (prop.startsWith('filter_') || ['min_price', 'max_price'].includes(prop)) {
                    if (this.activeFiltersList[prop] === '') {
                        delete data[prop];
                    } else {
                        data[prop] = this.activeFiltersList[prop];
                    }
                }
            }

            if (this.abortController) {
                this.abortController.abort();
            }

            const productsContainer = document.querySelectorAll('.product-catalog .products');
            productsContainer.forEach((products) => {
                products.classList.remove('loading-block-loaded');
                setTimeout(() => products.classList.add('loading-block'), 100);
            });

            this.timeout = setTimeout(async () => {
                let response = null;
                try {
                    this.abortController = new AbortController();
                    response = await Axios.post(`${theme.rest_route}products/list/`, {
                        filters: data
                    }, {
                        headers: {},
                        signal: this.abortController.signal
                    });
                    if (response.data) {
                        response = response.data;
                    }
                    this.abortController = null;
                } catch (error) {
                    if (error.response) {
                        response = error.response.data.data;
                    }
                }

                if (response) {
                    this.handleFilterResponse(response);
                }

            }, 1000);
            return;
        }

        this.timeout = setTimeout(() => {
            location.reload();
        }, 1000);
    }

    handleFilterResponse(response) {
        const productsContainer = document.querySelectorAll('.product-catalog .products, .product-catalog .woocommerce-no-products-found');
        productsContainer.forEach(function(products) {
            products.outerHTML = response.products_html;

            setTimeout(() => products.classList.remove('loading-block-loaded'), 1000);
        });

        const resultCountContainer = document.querySelectorAll('.woocommerce-result-count');
        resultCountContainer.forEach(function(results) {
            results.outerHTML = response.results_html;
        });

        const paginationContainer = document.querySelectorAll('.woocommerce-pagination');
        paginationContainer.forEach(function(pagination) {
            pagination.outerHTML = response.pagination_html;
        });
    }
}